import request from "@/utils/request";

export function getHostOrgSetting(data) {
  return request({
    url: "/htgl/getHostOrgSetting",
    method: "post",
    data,
  });
}



export function h5Student(data) {
  return request({
    url: "/kaosheng/mobile/h5Student",
    method: "post",
    data,
  });
}
export function mobilelogin(data) {
  return request({
    url: "/kaosheng/mobile/login",
    method: "post",
    data,
  });
}

